import React, { useMemo } from 'react';
import SplitButton from "../Common/SplitButton";
import axios from "axios";
import { useEffect, useState } from "react";
import config from "../../config";
import { useSelector } from "react-redux";
import loadingImg from "../../assets/loading.gif"

const OrderManagement = () => {

    const companyId = useSelector((state) => state.user.companyId);
    const [list, setList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [action, setAction] = useState(0);
    const [isMobileView, setIsMobileView] = useState(() => window.innerWidth < 768);


    useEffect(() => {

        setList([]);
        getOpenBatchIds(companyId);

    }, [])

    useEffect(() => {
        const handleResize = () => setIsMobileView(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const getOpenBatchIds = async (companyId, showLoader = true) => {
        if (showLoader) {
            setIsPageLoading(true);
        }

        try {
            //const res = await axios.get(config.BL_API_URL + "/client/v1/getUnprocessedBatches", { params: { companyId } });
            const res = await axios.get(`${config.BL_API_URL}/client/v1/getUnprocessedBatches/${companyId}`);

            if (res.status === 200) {
                setList(res.data);
            }

        } catch (err) {
            console.log(err)
        } finally {
            if (showLoader) {
                setIsPageLoading(false);
            }
        }

    }


    const applyAction = async () => {
        if (isPageLoading || isLoading) {
            return;
        }

        console.log("Action " + action);
        
        console.log("Action ..." + action)
        try {
            if (action === 0 || action === undefined) {
                return;
            }

            let actionUrl;
            if (Number(action) === 1) {
                actionUrl = "applyAction"

            } else if (Number(action) === 2) {

                actionUrl = "changeToError"

            } else if (Number(action) === 4) {
                actionUrl = "changeToOpen"

            } else if (Number(action) === 3) {
                actionUrl = "changeToOnHold"

            }
            console.log("Value ... " + actionUrl)
            if (actionUrl !== null && actionUrl !== "" && actionUrl !== undefined) {
                setIsLoading(true);

                const res = await axios.post(config.BL_API_URL + "/client/v1/" + actionUrl, list);

                if (res.status === 200) {
                    await getOpenBatchIds(companyId, false);
                }                
            }
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
            console.log(err)
        }
    }

    const onSelectionChange = (e) => {
        if (isPageLoading) {
            return;
        }

        if (e.target.value === "-") {
            return;
        }
        setAction(e.target.value);
    }

    const handleRefresh = () => {
        if (isPageLoading || isLoading) {
            return;
        }

        setIsAllChecked(false);
        setList([]);
        getOpenBatchIds(companyId, true);
    };

    const handleCheckAll = (event) => {
        if (isPageLoading) {
            return;
        }

        const newItems = list.map(item => ({
            ...item,
            isChecked: event.target.checked,
        }));
        setList(newItems);
        setIsAllChecked(event.target.checked);
    };

    const handleCheck = (id) => {
        if (isPageLoading) {
            return;
        }

        const newItems = list.map(item => {
            if (item.batchId === id) {
                return { ...item, isChecked: !item.isChecked };
            }
            return item;
        });
        setList(newItems);

        // Update isAllChecked based on individual checks
        setIsAllChecked(newItems.every(item => item.isChecked));
    };

    const getBatchPrefix = (batchId) => {
        if (!batchId) {
            return "";
        }

        return String(batchId).split('_')[0].trim();
    };

    const getMessageValue = (message) => {
        return String(message || '').trim();
    };

    const getMessageDisplayValue = (prefix, message) => {
        const normalizedMessage = getMessageValue(message);

        if (!normalizedMessage) {
            return '';
        }

        const escapedPrefix = prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const prefixRegex = new RegExp(`^${escapedPrefix}[\\s_:-]*`, 'i');
        const trimmedMessage = normalizedMessage.replace(prefixRegex, '').trim();

        return trimmedMessage || normalizedMessage;
    };

    const getSideValue = (item) => {
        const rawSide = String(item?.orderType || item?.action || '').trim().toUpperCase();

        if (rawSide === 'B' || rawSide === 'BUY') {
            return 'Buy';
        }

        if (rawSide === 'S' || rawSide === 'SELL') {
            return 'Sell';
        }

        return String(item?.orderType || item?.action || '').trim();
    };

    const selectRows = (matcher) => {
        const newItems = list.map(item => ({
            ...item,
            isChecked: matcher(item),
        }));

        setList(newItems);
        setIsAllChecked(newItems.length > 0 && newItems.every(item => item.isChecked));
    };

    const selectByBatchPrefix = (prefix) => {
        selectRows((item) => getBatchPrefix(item.batchId) === prefix);
    };

    const selectByBatchPrefixAndMessage = (prefix, message) => {
        selectRows((item) => {
            const itemPrefix = getBatchPrefix(item.batchId);
            const itemMessage = getMessageValue(item.status);

            return itemPrefix === prefix && itemMessage === message;
        });
    };

    const selectByBatchPrefixMessageAndSide = (prefix, message, side) => {
        selectRows((item) => {
            const itemPrefix = getBatchPrefix(item.batchId);
            const itemMessage = getMessageValue(item.status);
            const itemSide = getSideValue(item);

            return itemPrefix === prefix && itemMessage === message && itemSide === side;
        });
    };

    const batchSelectionOptions = useMemo(() => {
        const groupedOptions = new Map();

        list.forEach((item) => {
            const prefix = getBatchPrefix(item.batchId);
            const message = getMessageValue(item.status);
            const side = getSideValue(item);

            if (!prefix) {
                return;
            }

            if (!groupedOptions.has(prefix)) {
                groupedOptions.set(prefix, new Map());
            }

            if (message && side) {
                if (!groupedOptions.get(prefix).has(message)) {
                    groupedOptions.get(prefix).set(message, new Set());
                }

                groupedOptions.get(prefix).get(message).add(side);
            } else if (message) {
                if (!groupedOptions.get(prefix).has(message)) {
                    groupedOptions.get(prefix).set(message, new Set());
                }
            }
        });

        return Array.from(groupedOptions.entries()).map(([prefix, messageMap]) => ({
            label: prefix,
            onClick: () => selectByBatchPrefix(prefix),
            children: Array.from(messageMap.entries()).flatMap(([message, sideSet]) => {
                const displayMessage = getMessageDisplayValue(prefix, message);
                const sides = Array.from(sideSet);

                if (sides.length === 0) {
                    return [{
                        label: `${prefix} - ${displayMessage}`,
                        onClick: () => selectByBatchPrefixAndMessage(prefix, message),
                    }];
                }

                return sides.map((side) => ({
                    label: `${prefix} - ${displayMessage} - ${side}`,
                    onClick: () => selectByBatchPrefixMessageAndSide(prefix, message, side),
                }));
            }),
        }));
    }, [list]);

    return (
        <div>
            <div className="my-14 md:px-14 p-2 max-w-screen-xl mx-auto ">
                <div className="flex flex-col">
                    <div className={`border rounded-lg divide-y divide-gray-200 ${isPageLoading ? 'pointer-events-none select-none' : ''}`}>
                        <div className='col-span-2'>
                            <div className=" col-span-1">
                                <div className='row-span-1 flex flex-wrap justify-start md:justify-center content-center items-center gap-2 py-2 px-3'>
                                    <div className='col-span-1'>
                                        <label className='px-6 py-2 text-left font-medium' >Action</label>
                                    </div>
                                    <div className='col-span-1'>
                                        <select onChange={onSelectionChange} id="batchId" name="batchId" defaultValue="-" disabled={isPageLoading || isLoading} className='border border-gray-300 rounded-md disabled:opacity-60 disabled:cursor-not-allowed' >
                                            <option value="-">Select</option>
                                            <option value="1">Remove</option>
                                            <option value="2">Move to Error</option>
                                            <option value="3">Move to OnHold</option>
                                            <option value="4">Move to Open</option>
                                        </select>
                                    </div>
                                    <div className='col-span-1'>
                                        <button onClick={e => applyAction()} disabled={isPageLoading || isLoading}
                                            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center disabled:opacity-60 disabled:cursor-not-allowed">
                                            {isLoading &&
                                                <img src={loadingImg} alt="Icon" className="w-6 text-left justify-start items-right" />
                                            }
                                            {!isLoading &&
                                                <svg className="fill-current w-6 h-6 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><polyline fill="none" points="3.7 14.3 9.6 19 20.3 5" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" /></svg>
                                            }
                                            <span>Apply</span>
                                        </button>
                                    </div>
                                    <div className='col-span-1'>
                                        <button
                                            type="button"
                                            onClick={handleRefresh}
                                            disabled={isPageLoading || isLoading}
                                            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center disabled:opacity-60 disabled:cursor-not-allowed"
                                        >
                                            <svg className="fill-current w-5 h-5 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M17.65 6.35A7.95 7.95 0 0 0 12 4V1L7 6l5 5V7a5 5 0 1 1-4.9 6h-2.02A7 7 0 1 0 17.65 6.35z" />
                                            </svg>
                                            <span>Refresh</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!isMobileView && <div className="max-h-96 overflow-y-auto">
                            {isPageLoading ? (
                                <div className="py-8 px-3 flex justify-center items-center text-gray-600">
                                    <div className="flex items-center gap-3">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                                        <span>Loading orders...</span>
                                    </div>
                                </div>
                            ) : (
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-200 sticky top-0 z-10">
                                    <tr>
                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">#</th>
                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">
                                            <SplitButton
                                                mainLabel="All"
                                                onMainClick={() => handleCheckAll({ target: { checked: !isAllChecked } })}
                                                options={batchSelectionOptions}
                                            />
                                        </th>
                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">Batch Id</th>
                                        <th scope="col" className="px-6 py-2 text-left text-xs font-medium text-gray-500 bg-gray-200 uppercase">Batch Order Type</th>
                                        <th scope="col" className="px-6 py-2 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Action</th>
                                        <th scope="col" className="px-6 py-2 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Client Code</th>
                                        <th scope="col" className="px-6 py-2 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list &&
                                        list.map((item, index) => (
                                            <tr key={index} className={`${index % 2 === 0 ? 'bg-white' : 'bg-gray-100'} hover:bg-gray-300`}>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{index + 1}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">
                                                    <input type='checkbox' id={item.batchId} checked={!!item.isChecked}
                                                        onChange={() => handleCheck(item.batchId)} />
                                                </td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.batchId}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.orderType}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.action}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.clientCode}</td>
                                                <td className="px-6 py-3 whitespace-nowrap text-sm text-gray-800">{item.status}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                            )}
                        </div>}

                        {isMobileView && (
                            <div className="space-y-3 px-2 py-2">
                                {isPageLoading ? (
                                    <div className="py-6 px-3 flex justify-center items-center text-gray-600">
                                        <div className="flex items-center gap-3">
                                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                                            <span>Loading orders...</span>
                                        </div>
                                    </div>
                                ) : (
                                    list.map((item, index) => (
                                        <div key={index} className="rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
                                            <div className="flex items-start justify-between gap-2">
                                                <div>
                                                    <p className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Batch Id</p>
                                                    <p className="text-sm font-semibold text-gray-800 break-all">{item.batchId || "-"}</p>
                                                </div>
                                                <input type='checkbox' checked={!!item.isChecked} onChange={() => handleCheck(item.batchId)} />
                                            </div>
                                            <div className="mt-2 grid grid-cols-1 gap-1.5 text-sm">
                                                <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Order Type</span><p className="text-gray-800">{item.orderType || "-"}</p></div>
                                                <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Action</span><p className="text-gray-800">{item.action || "-"}</p></div>
                                                <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Client Code</span><p className="text-gray-800">{item.clientCode || "-"}</p></div>
                                                <div><span className="block text-[11px] font-semibold tracking-wide uppercase text-gray-700">Message</span><p className="text-gray-800">{item.status || "-"}</p></div>
                                            </div>
                                        </div>
                                    ))
                                )}
                                {!isPageLoading && list.length === 0 && (
                                    <p className="text-center text-red-500 text-sm">No records to display!</p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderManagement;
